export default "https://cdn-static.gokick.com/assets/0d39bc0fcec85c93d0d6a7d8f262b967dc26f977/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";